<template>
  <el-form
    ref="customForm"
    class="c-custom_form"
    :rules="rules"
    :label-width="labelWidth"
    v-bind="$attrs"
    @submit.native.prevent
  >
    <div class="c-custom_form__content">
      <el-form-item
        v-for="(item, index) in formData"
        :key="index"
        :label="item.label"
        :label-width="item.labelWidth || null"
        :prop="item.isProp == false ? undefined : item.prop"
        :class="[`${item.prop}_${item.class ? item.class() : 'item'}`]"
        v-show="item.isShow == false || item.isShow ? item.isShow : true"
      >
        <slot :name="item.prop"></slot>
      </el-form-item>
    </div>
    <div class="c-custom_form__footer">
      <el-form-item>
        <slot name="footer"></slot>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { debounce } from "@/components/aiChat/utils/tbox.js";
import AsyncValidator from "async-validator";
export default {
  name: "CustomForm",
  props: {
    useSelfValidate: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: [String, Number],
      default: "90px",
    },
    formData: {
      require: true,
      type: Array,
      default() {
        return [];
      },
    },
    debounceWait: {
      type: Number,
      default: 500,
    },
    isScrollIntoView: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rules: {},
    };
  },
  mounted() {},
  methods: {
    // 初始化处理rules
    onInitRules(formData) {
      const rules = {};
      const result = formData.some((item) => {
        return item.rules;
      });
      if (!result) return rules;
      formData.forEach((item) => {
        if (item.prop) {
          rules[item.prop] = item.rules;
        }
      });
      return rules;
    },
    // 处理自定义校验规则
    onSelfValidate(rules, model, callback = () => {}) {
      let rulesKey = Object.keys(rules);
      for (let i = 0; i < rulesKey.length; i++) {
        let descriptor = {};
        let key = rulesKey[i];
        if (rules[key]) {
          descriptor[key] = rules[key];
          const validator = new AsyncValidator(descriptor);
          validator.validate(model, (errors, invalidFields) => {
            if (errors) {
              let errorMessage = errors[0].message;
              callback(errorMessage, invalidFields);
            }
            callback();
          });
        }
      }
    },
    // 提交
    onSubmit(cb = () => {}, errorCb, thirdCb) {
      return debounce(() => {
        let errorMessageArr = [];
        let validateTotal = Object.values(this.rules).filter(
          (item) => item
        ).length;
        let index = 0;
        if (this.useSelfValidate) {
          this.onSelfValidate(
            this.rules,
            this.$attrs.model,
            (errorMessage, invalidFields) => {
              if (errorMessage) errorMessageArr.push(errorMessage);
              if (index == validateTotal - 1) {
                if (errorMessageArr.length == 0) {
                  if (cb) cb();
                } else {
                  if (cb) cb(errorMessageArr[0], invalidFields);
                }
              }
              index++;
            }
          );
        } else {
          this.$refs.customForm.validate((valid) => {
            if (valid) {
              this.$emit("on-form-submit");
              if (cb) cb(1);
            } else {
              if (thirdCb) thirdCb(0);
              if (errorCb && typeof errorCb == "function") {
                if (errorCb) errorCb(false);
                return;
              }
              this.$nextTick(() => {
                // 为了解决多个触发表单校验事件
                // 有点low 后期改
                if (!this.isScrollIntoView) return;
                const errorAddress = document.getElementsByClassName(
                  "el-form-item is-error"
                )[0];
                errorAddress.id = "error_address_by_form";
                document
                  .querySelector("#error_address_by_form")
                  .scrollIntoView({
                    behavior: "smooth", // 定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"
                    block: "center", // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
                    inline: "nearest", // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"
                  });
                errorAddress.id = "";
              });
              return false;
            }
          });
        }
      }, this.debounceWait)();
    },
    // 部分/单个校验（不带debounce）
    onValidateField(prop, cb = () => {}) {
      this.$refs.customForm.validateField(prop, cb);
    },
    // 校验全部（不带debounce）
    onValidate(cb = () => {}) {
      this.$refs.customForm.validate(cb);
    },
    onClearValidate(field = "") {
      this.$refs.customForm.clearValidate(field);
    },
  },
  watch: {
    formData: {
      handler: function (n) {
        this.rules = this.onInitRules(n);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-custom_form {
  .c-custom_form__content {
    ::v-deep .el-form-item {
      margin-bottom: 20px;

      .el-form-item__label {
        white-space: nowrap;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        padding: 0 8px 0 0;
        line-height: 32px;
        flex-shrink: 0;
        white-space: nowrap;
        &::before {
          position: relative;
          top: 2px;
        }
      }
      .el-form-item__content {
        line-height: 30px;
        font-size: 12px;
      }
      .el-form-item__error {
        padding-top: 0;
        top: 110%;
      }
      &:last-child {
        margin-bottom: 0 !important;
      }
    }
  }
  .c-custom_form__footer {
    ::v-deep .el-form-item {
      padding: 0 !important;
      margin-bottom: 0;
    }
  }
}
</style>